import { useEffect, useMemo, useRef, useState } from 'react';
import { useWSMessage } from '../context/WSMessageContext';

export default function useWSMessageTicks() {
  const { messages } = useWSMessage();
  const [activeTick, setActiveTick] = useState(null);
  const prevMessagesLength = useRef(0);

  // Filtra só mensagens do tipo "TICK"
  const tickMessages = useMemo(() =>
    messages.filter(msg => msg.type === 'TICK'),
    [messages]
  );

  // Processa a fila de mensagens TICK
  const processTickQueue = (queue, currentTime) => {
    const DURATION = 1000; // 1 segundo por tick (frequência diferente)

    const foundTick = queue.find(tick => {
      const startTime = tick.timestamp;
      const endTime = tick.timestamp + DURATION;
      return currentTime >= startTime && currentTime < endTime;
    }) || null;

    return foundTick || { type: "TICK", content: "Aguardando ticks...", timestamp: Date.now() };
  };

  // Atualiza mensagens ativas
  useEffect(() => {
    if (tickMessages.length === 0) return;

    if (tickMessages.length > prevMessagesLength.current) {
      prevMessagesLength.current = tickMessages.length;
    }
  }, [tickMessages]);

  // Intervalo para processar fila de ticks (frequência diferente)
  useEffect(() => {
    const interval = setInterval(() => {
      const active = processTickQueue(tickMessages, Date.now());
      setActiveTick(active);
    }, 100); // 100ms para ticks (mais frequente)

    return () => clearInterval(interval);
  }, [tickMessages]);

  return {
    messages: tickMessages,
    activeTick,
    setActiveTick
  };
}
